import React from 'react';
import './transitions.css';
import './Chat.css';

function BouncingEllipsis() {
  return (
    <span className="connection-ellipsis" aria-hidden="true">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
}

/**
 * Connection UX phases:
 * - mid: floating center pill while auto-reconnecting
 * - top: escalated banner after a long wait
 * - failed: auto-reconnect stopped; Retry required
 */
function ConnectionStatus({ phase, onRetry }) {
  if (phase === 'ready' || phase === 'bootstrapping') return null;

  const isFailed = phase === 'failed';
  const label = isFailed ? 'Couldn’t reconnect' : 'Reconnecting';

  if (phase === 'mid') {
    return (
      <div
        className="connection-status connection-status--mid"
        role="status"
        aria-live="polite"
        aria-label="Reconnecting to chat"
      >
        <span className="connection-status-pill chat-anim-rise">
          <span className="connection-status-label">
            {label}
            <BouncingEllipsis />
          </span>
        </span>
      </div>
    );
  }

  return (
    <div
      className={`connection-status connection-status--top${isFailed ? ' is-failed' : ''} chat-anim-fade`}
      role="status"
      aria-live="polite"
      aria-label={isFailed ? 'Connection failed' : 'Still reconnecting'}
    >
      <span className="connection-status-label">
        {label}
        {!isFailed && <BouncingEllipsis />}
      </span>
      {isFailed && (
        <button
          type="button"
          className="connection-status-retry"
          onClick={onRetry}
        >
          Retry
        </button>
      )}
    </div>
  );
}

export default ConnectionStatus;
